import { useLocales } from '@shared/locales'
import { Form, Input } from 'antd'

export const FormNomenclaturesJobPositions = () => {
  const { t } = useLocales()

  return (
    <Form.Item
      name="title"
      label={t('nomenclature.name')}
      rules={[{ required: true }]}
    >
      <Input />
    </Form.Item>
  )
}
